<template>
    <ChannelBackendEntityAssociationCmp 
        :association-service="associationService"
        :entity-plural="entityPlural" 
        :one-to-one="true" /> 
</template>

<script>
import ChannelBackendEntityAssociationCmp from '@/utils/components/ChannelBackendEntityAssociationCmp'
import brandService from '@/brand/services/BrandService'

export default {
    name: 'ChannelBrandListAssociationView',
    components: {
        ChannelBackendEntityAssociationCmp,
    },
    data() {
        return {
            associationService: brandService,
            entityPlural: "marcas",
        }
    },
}
</script>